import { useContext } from 'react';

import { TabelaAtributosContext } from 'contexts/TabelaAtributosContext';

export const useTabelaAtributos = () => {
  const context = useContext(TabelaAtributosContext);

  return context;
};
